import React, { FunctionComponent, PropsWithChildren } from 'react';

import {
  default as MuiTableCell,
  TableCellProps,
} from '@mui/material/TableCell';

const TableCell: FunctionComponent<TableCellProps> = (
  props: PropsWithChildren<TableCellProps>
) => {
  return <MuiTableCell {...props}>{props.children}</MuiTableCell>;
};

export default TableCell;
